
const formatPhone = (phone) => {
    if (!phone) return "";
    //remove non num
    phone = phone.replace(/\D/g, '');
    //if 11 remove first
    if (phone.length === 11) phone = phone.slice(1);
    //add brackets
    if (phone.length === 10) phone = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
    return phone;
    
}
export default formatPhone;